import { db, storage } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import { collection, getDocs } from "firebase/firestore";
import { getDownloadURL, ref } from 'firebase/storage';


const fetchResearchData = async (index) => {
    const d = await getDoc(doc(db, "research", String(index)));
    if (!d.exists()) {
        console.log('No such document!');
    } 
    return d.data()
}

function formatDate(date, separator = "-") {
    const day = String(date.getDate()).padStart(2, "0");      // 01–31
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 00-based → 01–12
    const year = date.getFullYear();                          // 2020

    return `${year}${separator}${month}${separator}${day}`;
}

const fetchAllNews = async (setData, setImgs) => {
    try {
        const q = collection(db, "news");
        const querySnapshot = await getDocs(q);
        let news = []
        querySnapshot.forEach((doc) => {
            const { title, description, link, ext, pinned, hidden, date } = doc.data()
            
            news = [...news, {
                title, description, link, ext, 
                pinned: pinned || false, 
                hidden: hidden || false,
                fileName: `${doc.id}`,
                id: doc.id,
                date: formatDate(date?.toDate())
            }]
            //console.log(date.toDate())
            
        })

        news.forEach(async n => {
            const imgURL = await getNewsImageURL(n.fileName)
            // await updateDoc(doc(db, "news", n.id), {
            //     url: imgURL
            // })
            setImgs(i => ({...i, [n.id]: imgURL}))
        })
        news.sort((a, b) => {
        if (a.pinned !== b.pinned) {
            return b.pinned - a.pinned; // true > false → pinned first
        }
        return new Date(b.date) - new Date(a.date);
        });
        
        setData(news)
    }
    catch (e) {
        console.error("Firebase Error: ", e);
    }
}

const getNewsImageURL = async (imageName) => {
    try {
        const imageRef = ref(storage, `news/${imageName}`);
        const url = await getDownloadURL(imageRef);
        return url;
    } catch (error) {
        console.error(`Error fetching image "${imageName}":`, error);
        return null;
    }
};


export { fetchResearchData, fetchAllNews}